// @flow

import styled from 'styled-components';
import { TYPE_SCALE_F4 } from 'styles/type-scale';
import { LINE_HEIGHT_COPY } from 'styles/line-height';
import { FONT_WEIGHT_100 } from 'styles/font-weight';
import { CLARK_SECONDARY } from 'styles/colors';

const MAX_WIDTH = '368px';
const Copy = styled.p`
  ${TYPE_SCALE_F4};
  ${FONT_WEIGHT_100};
  ${LINE_HEIGHT_COPY};
  color: ${CLARK_SECONDARY};
  max-width: ${MAX_WIDTH};
`;

export default Copy;



// WEBPACK FOOTER //
// ./src/components/sessions/list/empty/styles.js